module.exports = __webpack_public_path__ + "static/img/usBottom10.ea53546.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/usBottom10.png
// module id = jP90
// module chunks = 2